<template>
  <DSDialog
    :open="isOpen"
    @update:open="updateOpen"
  >
    <DSDialogContent>
      <DSDialogHeader>
        <DSDialogTitle>Contact Support</DSDialogTitle>
        <DSDialogDescription>
          <p>Live chat is not available right now.</p>
          <p>
            Please reach out to us at
            <a
              href="mailto:support@allposit.com"
              class="text-primary underline hover:no-underline"
            >support@allposit.com</a>
            and we'll get back to you shortly.
          </p>
        </DSDialogDescription>
      </DSDialogHeader>
    </DSDialogContent>
  </DSDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { DSDialog, DSDialogContent, DSDialogDescription, DSDialogHeader, DSDialogTitle } from '@ds'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)

const updateOpen = (value: boolean) => {
  if (!value) props.modal.close()
}
</script>
